import React, { useRef, useEffect } from 'react';
import './waterMark.less';

const Watermark = ({ text }) => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        canvas.width = 400;
        canvas.height = 300;
        ctx.font = '14px Arial';
        ctx.fillStyle = 'rgba(150, 150, 150, 0.08)';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.translate(150, 100);
        ctx.rotate(-Math.atan(100 / 150));
        ctx.fillText(text, 0, 0);


        var watermark = document.getElementById('watermark'); 
        watermark.style.backgroundImage = 'url(' + canvas.toDataURL('image/png') + ')';
    }, [text]);

    return (
        <div className="watermark" id="watermark">
            <canvas ref={canvasRef} style={{ display: 'none' }} />
        </div>
    );
};

export default Watermark;